module.exports = __webpack_public_path__ + "img/lr_11.236a6f39.png";